import React, { useRef } from "react"
import { postSocial, postSocialText, button } from "./social-panel.module.scss"
import {
  FacebookShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
  LinkedinIcon,
} from "react-share"
import PropTypes from "prop-types"

const SocialPanel = ({ postData, location }) => {
  // Création des références pour les boutons de partage
  const facebookRef = useRef(null)
  const twitterRef = useRef(null)
  const whatsappRef = useRef(null)
  const linkedinRef = useRef(null)

  // Fonction pour déclencher le click sur un bouton de partage
  const handleClick = (buttonRef) => {
    if (buttonRef && buttonRef.current) {
      buttonRef.current.click()
    }
  }

  return (
    <div className={postSocial}>
      <p className={postSocialText}>Partagez sur :</p>
      <ul>
        <li>
          <a
            href="#"
            className={button}
            aria-label="Facebook"
            onClick={(event) => {
              event.preventDefault()
              handleClick(facebookRef)
            }}
          >
            <FacebookIcon size={30} round={true} aria-hidden={true} />
          </a>
          {/* Bouton Facebook caché */}
          <FacebookShareButton
            url={location}
            title={postData.title}
            ref={facebookRef}
            style={{ display: "none" }}
          />
        </li>
        <li>
          <a
            href="#"
            className={button}
            aria-label="Twitter"
            onClick={(event) => {
              event.preventDefault()
              handleClick(twitterRef)
            }}
          >
            <TwitterIcon size={32} round={true} aria-hidden={true} />
          </a>
          {/* Bouton Twitter caché */}
          <TwitterShareButton
            url={location}
            title={postData.title}
            ref={twitterRef}
            style={{ display: "none" }}
          />
        </li>
        <li>
          <a
            href="#"
            className={button}
            aria-label="WhatsApp"
            onClick={(event) => {
              event.preventDefault()
              handleClick(whatsappRef)
            }}
          >
            <WhatsappIcon size={32} round={true} aria-hidden={true} />
          </a>
          {/* Bouton WhatsApp caché */}
          <WhatsappShareButton
            url={location}
            title={postData.title}
            ref={whatsappRef}
            style={{ display: "none" }}
          />
        </li>
        <li>
          <a
            href="#"
            className={button}
            aria-label="LinkedIn"
            onClick={(event) => {
              event.preventDefault()
              handleClick(linkedinRef)
            }}
          >
            <LinkedinIcon size={32} round={true} aria-hidden={true} />
          </a>
          {/* Bouton LinkedIn caché */}
          <LinkedinShareButton
            url={location}
            title={postData.title}
            ref={linkedinRef}
            style={{ display: "none" }}
          />
        </li>
      </ul>
    </div>
  )
}

SocialPanel.propTypes = {
  postData: PropTypes.object.isRequired,
  location: PropTypes.string,
}

export default SocialPanel
